import React, { FC } from 'react';
import { Rate } from 'antd';
import styled from 'styled-components';
import Star from '../../../static/icons/star.inline.svg';
import { colors } from 'styles/colors';

const Rating = styled<any>(Rate)`
  &.ant-rate {
    color: ${colors.primary};
    & svg {
      width: ${({ size }) => `${size}px`};
      height: ${({ size }) => `${size}px`};
    }
  }
  & .ant-rate-star:not(:last-child) {
    margin-right: ${({ spaceStars }) => `${spaceStars}px`};
  }
`;

type Props = {
  onChange?: (value: number) => void;
  value: number;
  spaceStars?: number;
  allowChange?: boolean;
  size?: number;
};

export const StarsRating: FC<Props> = ({
  onChange,
  value,
  spaceStars = 8,
  allowChange = false,
  size = 49,
}) => (
  <Rating
    character={<Star />}
    size={size}
    disabled={!allowChange}
    allowHalf={!allowChange}
    spaceStars={spaceStars}
    onChange={onChange}
    value={value}
  />
);
